<div class="co-fb-container">
    <swiper class="co-fb-quick-container" [config]="categoryListConfig">
        <div class="swiper-wrapper">
            <button
                class="swiper-slide co-fb-quick-filter-button"
                *ngFor="let quickFilter of quickFilters"
                (click)="quickFilterClicked(quickFilter)"
                [ngClass]="{ selected: quickFilter.isSelected }"
            >
                {{ quickFilter.filterNameToShow }}
            </button>
        </div>
        <div class="fade-overlay"></div>
        <ion-icon
            class="swiper-button-prev"
            name="chevron-back-circle-outline"
        ></ion-icon>
        <ion-icon
            class="swiper-button-next"
            name="chevron-forward-circle-outline"
        ></ion-icon>
    </swiper>
    <div class="co-fb-all-filters">
        <button
            class="co-fb-quick-filter-button co-fb-filters-all"
            [ngClass]="{
                'filters-set': nrOfAppliedFilters > 0
            }"
            (click)="openAllFiltersOffcanvas()"
        >
            <ion-icon name="options-outline"></ion-icon>
            {{ "Filters" | translate }}
        </button>
    </div>
</div>
<md-modal-offcanvas
    #allFiltersOffcanvas
    [mobileModalTitle]="'Filters' | translate"
    [mainButtonText]="
        ('Show ' | translate) + nrOfResults + (' Deals' | translate)
    "
    [showFooter]="true"
    (modalClearButtonClicked)="resetFilters()"
>
    <div actualControl>
        <md-category-deal-filter
            *ngFor="let filter of filterOptions; let i = index"
            [filterData]="filter"
            (filterChanged)="filterChanged($event)"
        ></md-category-deal-filter>
    </div>
</md-modal-offcanvas>
